import styled from 'styled-components'

export const StyledDiv = styled.div`
  font-size: 20px;
  display: flex;
  flex-wrap: wrap;
  height: 100%;
  width: 100%;
`
